export const GET_OPTIONS = "GET_OPTIONS"
export const GET_OPTIONS_REQUEST = "GET_OPTIONS_REQUEST"
export const GET_OPTIONS_SUCCESS = "GET_OPTIONS_SUCCESS"
export const GET_OPTIONS_ERROR = "GET_OPTIONS_ERROR"

export const UPDATE_OPTION = "UPDATE_OPTION"
export const UPDATE_OPTION_REQUEST = "UPDATE_OPTION_REQUEST"
export const UPDATE_OPTION_SUCCESS = "UPDATE_OPTION_SUCCESS"
export const UPDATE_OPTION_ERROR = "UPDATE_OPTION_ERROR"
